import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { SaleBudgetService } from "./sale-budget.service";
import { CommonResponse, RmBudgetResponseModel, SaleBudgetResponseModel } from "@gtpl/shared-models/masters";

@ApiTags('saleBudget')
@Controller('saleBudget')
export class SaleBudgetController {
    constructor(
        private service: SaleBudgetService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) {
    }
    @Post('/createSaleBudget')
    async createSaleBudget(@Body() data:any): Promise<SaleBudgetResponseModel>{
       try{
        return this.service.createSaleBudget(data);
       } catch(err){
        return this.applicationExceptionHandler.returnException(SaleBudgetResponseModel,err);
       }
    }
    @Post('/getAllSaleBudget')
    async getAllSaleBudget(): Promise<CommonResponse>{
       try{
        return this.service.getAllSaleBudget();
       } catch(err){
        return this.applicationExceptionHandler.returnException(CommonResponse,err);
       }
    }

    @Post('/getBudgetVarianceReport')
  async getBudgetVarianceReport(@Body() req: { month?: number; year?: number }): Promise<CommonResponse> {
   console.log(req,"reqqqqqqqqqqqqqqqqqqqq");
   
    try {
      return await this.service.getBudgetVarianceReport(req.month, req.year);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(CommonResponse, err);
    }
  }
}